"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Logo = require("../Logo");

var _Logo2 = _interopRequireDefault(_Logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const Sidebar = (_ref) => {
  let { children } = _ref,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react2.default.createElement(
    _Box2.default,
    props,
    _react2.default.createElement(
      _Flex2.default,
      { alignItems: "center", p: 2 },
      _react2.default.createElement(_Logo2.default, null)
    ),
    _react2.default.createElement(
      _Box2.default,
      { py: 3 },
      children
    )
  );
};

Sidebar.propTypes = {
  children: _propTypes2.default.node,
  width: _propTypes2.default.number
};

Sidebar.defaultProps = {
  bg: "palette.green.900",
  width: "200px"
};

exports.default = Sidebar;